import './style.modules.scss'

import React from 'react'

import {
  MostVisitedLinks,
  MostVisitedLinksProps
} from '../MostVisitedLinks/MostVisitedLinks'
import { SearchBox, SearchBoxProps } from '../SearchBox/SearchBox'

export type SearchPanelProps = {
  open: boolean
  searchBox: SearchBoxProps
  mostVisitedLinks?: MostVisitedLinksProps
  handleSearchClose?: () => void
}

export const SearchPanel = (props: SearchPanelProps) => {
  const { open, searchBox, mostVisitedLinks, handleSearchClose } = props

  if (!open) {
    return null
  }

  return (
    <>
      <div className="SearchPanel u-hidden u-lg-block u-bgColorLight u-paddingBottom64">
        {searchBox && (
          <div className="u-sizeConstrained u-paddingTop48 u-marginCenter u-flex">
            <div className="u-marginRight8 u-sm-sizeFull u-md-size8of12 u-lg-size6of12 u-md-before2of12 u-lg-before3of12">
              <SearchBox {...searchBox} />
            </div>
            <div className="u-sm-hidden u-md-size2of12 u-lg-size3of12 u-textCenter">
              <button
                className="SearchPanel-closeButton"
                onClick={handleSearchClose}
              >
                <span
                  className="adel-material-symbols u-textColorNeutral"
                  aria-hidden="true"
                  title="Close"
                >
                  close
                </span>
              </button>
            </div>
          </div>
        )}
        {mostVisitedLinks && (
          <div className="u-paddingTop64">
            <MostVisitedLinks {...mostVisitedLinks} />
          </div>
        )}
      </div>
      {open && (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        <div
          onClick={handleSearchClose}
          className="SearchPanel-overlay u-hidden u-lg-block"
        ></div>
      )}
    </>
  )
}
